var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRugby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "80.91 0.2 25.97 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "so-rugby",
    clipPath: "url(#clip0_695_1991)",
    filter: "url(#filter0_dddddd_695_1991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M105.459 1.59198C98.5213 -1.03458 90.8511 0.0252603 85.7905 5.0147C80.7298 10.0041 79.6548 17.5664 82.3189 24.4067C89.2568 27.0333 96.927 25.9734 101.988 20.984C107.048 15.9945 108.123 8.4323 105.459 1.59198Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.9497 23.1195C87.4013 22.2615 86.7573 21.4668 86.0296 20.7502C85.3022 20.0327 84.4957 19.3977 83.6252 18.8571C83.5072 17.8734 83.4781 16.8813 83.5382 15.8926C85.1416 16.6656 86.6038 17.6954 87.8653 18.9403C89.1269 20.1845 90.171 21.6261 90.9552 23.2065C89.9527 23.266 88.9469 23.2368 87.9497 23.1195Z",
    fill: "#463649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M98.8574 14.4733C98.6139 14.7133 98.2837 14.8481 97.9395 14.8481C97.5952 14.8481 97.2651 14.7133 97.0216 14.4733L95.626 13.0973L93.9902 14.7101L95.3871 16.0861C95.5111 16.2042 95.61 16.3455 95.678 16.5016C95.7461 16.6578 95.7819 16.8257 95.7834 16.9957C95.7849 17.1657 95.752 17.3342 95.6868 17.4915C95.6215 17.6488 95.5251 17.7917 95.4032 17.9119C95.2813 18.0321 95.1363 18.1272 94.9768 18.1915C94.8172 18.2559 94.6463 18.2883 94.4739 18.2868C94.3015 18.2853 94.1312 18.25 93.9728 18.1829C93.8144 18.1158 93.6711 18.0183 93.5514 17.8961L92.1544 16.5201L91.3378 17.3265C91.093 17.5596 90.765 17.6886 90.4246 17.6857C90.0842 17.6828 89.7586 17.5482 89.5179 17.3109C89.2772 17.0735 89.1406 16.7525 89.1377 16.4169C89.1347 16.0813 89.2656 15.7579 89.5021 15.5165L90.3187 14.7101L88.923 13.3341C88.6865 13.0927 88.5557 12.7694 88.5586 12.4338C88.5616 12.0982 88.6981 11.7771 88.9388 11.5398C89.1796 11.3025 89.5052 11.1679 89.8456 11.165C90.186 11.162 90.5139 11.2911 90.7588 11.5242L92.1544 12.9002L93.7902 11.2874L92.3933 9.91142C92.1568 9.67001 92.026 9.34668 92.0289 9.01107C92.0319 8.67545 92.1684 8.35441 92.4091 8.11709C92.6498 7.87977 92.9754 7.74515 93.3158 7.74224C93.6562 7.73932 93.9842 7.86834 94.229 8.1015L95.626 9.4775L96.4439 8.6711C96.6887 8.43794 97.0167 8.30892 97.3571 8.31184C97.6975 8.31475 98.0231 8.44937 98.2638 8.68669C98.5045 8.92401 98.6411 9.24505 98.644 9.58066C98.647 9.91628 98.5161 10.2396 98.2796 10.481L97.4617 11.2874L98.8574 12.6634C99.1008 12.9035 99.2375 13.229 99.2375 13.5684C99.2375 13.9078 99.1008 14.2333 98.8574 14.4733Z",
    fill: "#463649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M104.24 10.1069C102.637 9.33396 101.174 8.30409 99.9128 7.05926C98.6513 5.81611 97.6076 4.37535 96.8242 2.79558C97.8266 2.73632 98.8324 2.76502 99.8297 2.88134C100.378 3.73854 101.022 4.53279 101.749 5.24934C102.476 5.96683 103.282 6.60182 104.153 7.14246C104.271 8.12613 104.3 9.11819 104.24 10.1069Z",
    fill: "#463649"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_695_1991",
    x: 0.90625,
    y: 0.199219,
    width: 185.965,
    height: 205.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_695_1991"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.143771 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_695_1991",
    result: "effect2_dropShadow_695_1991"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.119221 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_695_1991",
    result: "effect3_dropShadow_695_1991"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_695_1991",
    result: "effect4_dropShadow_695_1991"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0807786 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_695_1991",
    result: "effect5_dropShadow_695_1991"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0562291 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_695_1991",
    result: "effect6_dropShadow_695_1991"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_695_1991",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_1991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9653,
    height: 25.6,
    fill: "white",
    transform: "translate(80.9062 0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRugby);
export default __webpack_public_path__ + "static/media/rugby.43b73811a1c29257b17eee686afd52cf.svg";
export { ForwardRef as ReactComponent };